// extracted by mini-css-extract-plugin
export default {"alignCenter":"rotina-temp-email_alignCenter__iHQe9","buttons":"rotina-temp-email_buttons__7msRq"};